<template>
  <div class="details">
    <form-title>行业详情</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col :span="col">
          <info-item label="行业名称">
            {{ result.evaluationName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="价格">
            {{ format(result.price) }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="分销金额">
            {{ format(result.distributionAmount) }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="虚拟价格标签">
            {{ result.priceTag }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="虚拟价格">
            {{ format(result.fakePrice) }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="虚拟购买数量">
            {{ result.virtualBuyCount }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="排序值">
            {{ result.rank }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <info-item label="行业介绍">
            <div v-html="result.evaluationDesc" />
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <info-item label="抽奖活动规则">
            <div v-html="result.lotteryRuleIntro" />
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <!-- 题目分类 -->
    <form-title>题目分类</form-title>
    <div class="flex">
      <el-button
        type="primary"
        @click="openCategoryDialog"
      >
        新增题目分类
      </el-button>
    </div>
    <data-table
      :data="evaluationCategoryList"
      :pagination="false"
      :table-column="evaluationCategoryTableColumn"
      @buttonClick="buttonClickCategory"
    />
    <!-- 题目分类 -->
    <!-- 抽奖配置 -->
    <form-title>抽奖配置</form-title>
    <div class="flex">
      <el-button
        type="primary"
        @click="openAwardDialog"
      >
        新增抽奖配置
      </el-button>
    </div>
    <data-table
      :data="evaluationAwardList"
      :pagination="false"
      :table-column="evaluationAwardTableColumn"
      @buttonClick="buttonClickAward"
    />
    <!-- 抽奖配置 -->
    <award-dialog
      :dialog-visible.sync="awardDialogVisible"
      :item="awardItem"
      @confirm="getInfo()"
      @close="()=> awardItem = {}"
    />
    <!-- 抽奖配置 -->
    <!-- 题目分类 -->
    <evaluation-category-dialog
      :dialog-visible.sync="categoeyDialogVisible"
      :item.sync="evaluationCategoryItem"
      @confirm="getInfo"
    />
    <!-- 题目分类 -->
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import infoItem from '@/components/common/infoItem.vue';
import formTitle from '@/components/common/formTitle.vue';
import dataTable from '@/components/common/dataTable.vue';
import axClient from '@/services';
import types, { couponTypeList } from '@/config';
import awardDialog from './dialog/awardDialog.vue';
import evaluationCategoryDialog from './dialog/evaluationCategoryDialog.vue';

export default {
  name: 'AccountDetails',
  components: {
    formTitle,
    infoPanel,
    infoItem,
    dataTable,
    awardDialog,
    evaluationCategoryDialog,
  },
  data() {
    return {
      types,
      col: 5,
      result: {},
      awardDialogVisible: false,
      categoeyDialogVisible: false,
      evaluationCategoryList: [],
      evaluationAwardList: [],
      awardItem: null,
      evaluationCategoryItem: null,
      evaluationCategoryTableColumn: [
        {
          key: 'evaluationCategoryName',
          label: '分类名称',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'existsChoiceCount',
          label: '已存在选择题数量',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'existsTrueFalseCount',
          label: '已存在判断题数量',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'choiceCount',
          label: '选择题出题数量',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'trueFalseCount',
          label: '判断题出题数量',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'valid',
          label: '状态',
          width: '100px',
          dataType: 'component',
          renderProps: { [types.EVALUATION_CATEGORY_ENABLE]: '启用', [types.EVALUATION_CATEGORY_DISABLE]: '禁用', successKey: types.EVALUATION_CATEGORY_ENABLE },
          render: () => 'status',
        },
        {
          key: 'scoreListStr',
          label: '得分提示',
          dataType: 'text',
          substr: 10,
        },
        {
          key: 'control',
          label: '操作',
          width: '170px',
          dataType: 'component',
          renderProps: [
            {
              text: '禁用', renderKey: types.EVALUATION_CATEGORY_ENABLE, renderProp: 'valid', eventIndex: 0, disableKey: null,
            },
            {
              text: '启用', renderKey: types.EVALUATION_CATEGORY_DISABLE, renderProp: 'valid', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 1, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
      evaluationAwardTableColumn: [
        {
          key: 'awardName',
          label: '奖品名称',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'couponName',
          label: '优惠券名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'discountFee',
          label: '优惠券金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'winWeight',
          label: '中奖权重',
          width: 'auto',
          dataType: 'text',
          tips: '权重越高,中奖概率越大',
        },
        {
          key: 'couponType',
          label: '优惠券类型',
          width: '100px',
          dataType: 'function',
          render: (key) => couponTypeList.filter((item) => item.value === key),
        },
        {
          key: 'valid',
          label: '状态',
          width: '100px',
          dataType: 'component',
          renderProps: { [types.EVALUATION_CATEGORY_ENABLE]: '启用', [types.EVALUATION_CATEGORY_DISABLE]: '禁用', successKey: types.EVALUATION_CATEGORY_ENABLE },
          render: () => 'status',
        },
        {
          key: 'control',
          label: '操作',
          width: '170px',
          dataType: 'component',
          renderProps: [
            {
              text: '禁用', renderKey: types.EVALUATION_CATEGORY_ENABLE, renderProp: 'valid', eventIndex: 0, disableKey: null,
            },
            {
              text: '启用', renderKey: types.EVALUATION_CATEGORY_DISABLE, renderProp: 'valid', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 1, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // table 传递过来的按钮点击
    buttonClickCategory(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item, 'category');
          break;
        case 1:
          this.evaluationCategoryItem = item;
          this.categoeyDialogVisible = true;
          break;
        default:
          break;
      }
    },
    // table 传递过来的按钮点击
    buttonClickAward(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item);
          break;
        case 1:
          this.awardItem = item;
          this.awardDialogVisible = true;
          break;
        default:
          break;
      }
    },
    // 打开抽奖配置弹窗
    openAwardDialog() {
      this.awardItem = null;
      this.awardDialogVisible = true;
    },
    // 打开抽奖配置弹窗
    openCategoryDialog() {
      this.evaluationCategoryItem = null;
      this.categoeyDialogVisible = true;
    },
    // 详情
    async getInfo() {
      this.result = await axClient.evaluation.evaluationgetDetail({
        id: this.$route.params.id,
      });
      this.evaluationCategoryList = await axClient.evaluation.evaluationCategoryList({
        id: this.$route.params.id,
      });
      this.evaluationAwardList = await axClient.evaluation.evaluationAwardList({
        id: this.$route.params.id,
      });
    },
    // 下架/上架 分类
    confirmDialog(item, type) {
      let title = '分类';
      if (type !== 'category') {
        title = '抽奖配置';
      }
      this.$confirm(`确定启用/禁用该${title}?`, `启用/禁用${title}`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id, valid } = item;
        if (type === 'category') {
          const data = await axClient.evaluation.evaluationCategoryUpdateValid(
            {
              id,
              valid: valid === types.EVALUATION_CATEGORY_ENABLE
                ? types.EVALUATION_CATEGORY_DISABLE : types.EVALUATION_CATEGORY_ENABLE,
            },
          );
          if (data) {
            this.$message.success('启用/禁用成功');
            this.getInfo();
          }
        } else {
          const data = await axClient.evaluation.evaluationAwardUpdateValid(
            {
              id,
              valid: valid === types.EVALUATION_CATEGORY_ENABLE
                ? types.EVALUATION_CATEGORY_DISABLE : types.EVALUATION_CATEGORY_ENABLE,
            },
          );
          if (data) {
            this.$message.success('启用/禁用成功');
            this.getInfo();
          }
        }
      });
    },
    // format
    format(money) {
      return `${money ? money / 100 : money}元`;
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  .flex {
    justify-content: flex-end;
    margin-bottom: 20px;
  }
}
</style>